import Api from '../api'

export default ({

  state: {
    adminUserLists: [],
    userLists: [],
    organizationLists: [],
    inquiryList: [],
    smsDetailsQueueLists: [],
    smsDetailsSentLists: [],
    smsDetailsFailedLists: []
  },
  mutations: {
    ADD_ADMIN_USER (state, adminUserLists) {
      let userList = state.adminUserLists.concat(adminUserLists)
      state.adminUserLists = userList
    },
    SET_ADMIN_USERS (state, userList) {
      state.adminUserLists = userList
    },
    SET_ALL_USERS (state, userList) {
      state.userLists = userList
    },
    ADD_ORGANIZATION (state, organizationLists) {
      let organizationList = state.organizationLists.concat(organizationLists)
      state.organizationLists = organizationList
    },
    SET_ORGANIZATION (state, organizationList) {
      state.organizationLists = organizationList
    },
    SET_INQUIRY(state, inquiryList) {
      state.inquiryList = inquiryList
    },
    DELETE_ADMIN_USER (state, userId) {
      let user = state.adminUserLists.filter(a => a.id !== userId.id)
      state.adminUserLists = user
    },
    DELETE_ORGANIZATION (state, organisationId) {
      let organisation = state.organizationLists.filter(a => a.id !== organisationId.id)
      state.organizationLists = organisation
    },
    UPDATE_ADMIN_USER(state, updatedUser) {
      state.adminUserLists = state.adminUserLists.map(user => user.id !== updatedUser.id ? user : {...user, ...updatedUser})
    },
    UPDATE_ORGANIZATION(state, updatedOrg) {
      state.organizationLists = state.organizationLists.map(org => org.id !== updatedOrg.id ? org : {...org, ...updatedOrg})
    },
    UPDATE_INQUIRY(state, updateInquiry) {
      state.inquiryList = state.inquiryList.map(inq => inq.id !== updateInquiry.id ? inq : {...inq, ...updateInquiry})
    },
    SET_SMS_Queue_LIST (state, smsList) {
      state.smsDetailsQueueLists = smsList
    },
    SET_SMS_SENT_LIST (state, smsList) {
      state.smsDetailsSentLists = smsList
    },
    SET_SMS_FAILED_LIST (state, smsList) {
      state.smsDetailsFailedLists = smsList
    }
  },
  actions: {
    async createAdminUser({commit}, user) {
      let response = await Api.request('post', '/organisation/addAdminUser/' + this.state.user.id, user)
      let savedUser = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ADMIN_USER', savedUser)
      }
      return response
    },
    async loadAdminUser({commit}) {
      let response = await Api.request('get', '/organisation/adminUsers', null)
      commit('SET_ADMIN_USERS', response.data.data)
    },
    async loadAllUser({commit}) {
      let response = await Api.request('get', '/organisation/allUsers', null)
      commit('SET_ALL_USERS', response.data.data)
    },
    async createOrganization({commit}, organisation) {
      let response = await Api.request('post', '/organisation/createOrganisation/' + this.state.user.id, organisation, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedOrganization = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ORGANIZATION', savedOrganization)
      }
      return response
    },
    async updateOrganization({commit}, org) {
      let response = await Api.request('put', '/organisation/updateOrganisation/', org, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let updateOrganization = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_ORGANIZATION', updateOrganization)
      }
      return response
    },
    async updateMergeFlag({ commit }, { orgId, mergeOrg, userId }) {
      const response = await Api.request('put', `/organisation/updateMergeFlag/${orgId}/${this.state.user.id}?mergOrg=${mergeOrg}`,
        null,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_ORGANIZATION', response.data.data)
      }
      return response
    },
    async updateIRDOrganization({commit}, org) {
      let response = await Api.request('put', '/organisation/updateIRDOrganisation/', org, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let updateOrganization = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_ORGANIZATION', updateOrganization)
      }
      return response
    },
    async loadOrganization({commit}) {
      let response = await Api.request('get', '/organisation/organisationList ', null)
      commit('SET_ORGANIZATION', response.data.data)
    },
    async loadOrganizationByParent({commit}) {
      let response = await Api.request('get', '/organisation/organisationListByParent/' + this.getters.organisationId, null)
      console.log(response)
      commit('SET_ORGANIZATION', response.data.data)
    },
    async deleteAdminUser({commit}, user) {
      let response = await Api.request('delete', '/organisation/deleteAdminUser/' + user.userId + '/' + this.state.user.id + '/' + user.deleteReason)
      let adminUserLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_ADMIN_USER', adminUserLists)
      }
      return response
    },
    async deleteOrganization({commit}, org) {
      let response = await Api.request('delete', '/organisation/deleteOrganisation/' + org.id + '/' + this.state.user.id + '/' + org.deleteReason)
      let organizationLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_ORGANIZATION', organizationLists)
      }
      return response
    },
    async updateAdminUser({commit}, user) {
      let response = await Api.request('put', '/organisation/updateAdminUser/' + user.userId + '/' + this.state.user.id, user)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_ADMIN_USER', response.data.data)
      }
      return response
    },
    async loadOrganisation({commit}) {
      let response = await Api.request('get', '/organisation/' + this.getters.organisationId, null)
      return response
    },
    async inquiryList({commit}) {
      let response = await Api.request('get', '/inquiry', null)
      if (response.data.status === 'SUCCESS') {
        commit('SET_INQUIRY', response.data.data)
      }
      return response
    },
    async updateInquiry({commit}, data) {
      let response = await Api.request('put', '/inquiry/' + data.id, data)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_INQUIRY', response.data.data)
      }
      return response
    },
    async loadAutoAdjustmentAccount({commit}) {
      let response = await Api.request('get', '/autoAdjustment/autoAdjustAccount/' + this.getters.organisationId + '/' + this.state.fyId, null)
      return response
    },
    async loadAutoAdjustmentInventory({commit}, data) {
      let response = await Api.request('get', '/autoAdjustment/autoAdjustStock/' + this.getters.organisationId + '/' + this.state.fyId + '/' + data.warehouse, null)
      return response
    },
    async uploadSmsExcelFormat({commit}, item) {
      let response = await Api.request('post', '/fileUpload/excelFileUploadForSms/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedItemMaster = response
      return savedItemMaster
    },
    async loadQueueSmsList({commit}) {
      let response = await Api.request('get', '/smsController/allSmsQueueReport/' + this.state.organisationid + '')
      commit('SET_SMS_Queue_LIST', response.data.data)
      return response
    },
    async loadSentSmsList({commit}) {
      let response = await Api.request('get', '/smsController/allSmsSentReport/' + this.state.organisationid + '')
      commit('SET_SMS_SENT_LIST', response.data.data)
      return response
    },
    async loadFailedSmsList({commit}) {
      let response = await Api.request('get', '/smsController/allSmsFailedReport/' + this.state.organisationid + '')
      commit('SET_SMS_FAILED_LIST', response.data.data)
      return response
    },
    async sendSms({commit}) {
      let response = await Api.request('put', '/smsController/sendSmsToAllQueue/' + this.state.organisationid + '/' + this.state.user.id + '')
      return response
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/admin.js